export interface PipelineMetrics {
  formingCount: number;
  formingAmount: number;
  gatesPassedCount: number;
  gatesPassedAmount: number;
  approvedCount: number;
  approvedAmount: number;
  cutCarryoverTotal: number;
  inBankCount: number;
  inBankAmount: number;
  paidTotal: number;
  partiallyPaidTotal: number;
  unpaidTotal: number;
}

export const STAGE_LABELS: Record<string, string> = {
  all: 'Все заявки',
  forming: '1. Сформировано',
  control: '2. Контроль гейтов',
  ceo_decision: '3. Решение Гендиректора',
  export_1c: '4. Выгружено в 1С',
  fact_statement: '5. Факт по выписке',
};
